<div style="display: flex; flex-direction: row">
	<div class="summary">{{ gistTranscript }}</div>
	<div style="position: relative">
		<row-tooltip [content]="tooltipString" *ngIf="transcriptSet"></row-tooltip>
		<row-tooltip [content]="'Loading...'" *ngIf="!transcriptSet"></row-tooltip>
		<button (mouseenter)="fetchTooltipData()" class="hoverButton" *ngIf="data?.has_transcript_in_bucket !== undefined && data?.has_transcript_in_bucket !== false">
			<fa-icon [icon]="'grip-lines'"></fa-icon>
		</button>
	</div>
</div>
